<script setup lang="ts">
import type { components } from '~/types/napis'

const props = defineProps({
  job: {
    type: Object as PropType<components['schemas']['JobResponseSchema']>,
    required: true
  }
})
</script>

<template>
  <div class="job-item">
    <img
      :src="toCompanyIconUrl(props.job.company_part?.logo_part?.object_key)"
      :alt="props.job.company_part?.name || 'Company Logo'"
      class="job-item-logo"
    >

    <div class="job-item-title">
      <NuxtLink :to="getJobPageUrl(job.id_slug, job.title)">
        <h4>
          {{ job.title }}
        </h4>
      </NuxtLink>
    </div>

    <NuxtLink
      v-if="props.job.company_part"
      :to="`/employers/${props.job.company_part?.id_slug}`"
      class="job-item-employer"
    >
      <p>{{ props.job.company_part?.name }}</p>
    </NuxtLink>

    <div v-if="props.job.location" class="job-item-details">
      <CommonIconJobsIconLocationOutline />
      <span> {{ getReadableJobLocation(props.job.location) }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.job-item {
  $padding: 20px;
  $logoSize: 50px;

  width: 100%;
  margin-bottom: 15px;
  padding: $padding;
  padding-left: calc($padding * 2 + $logoSize);

  img {
    height: $logoSize;
    width: $logoSize;
    position: absolute;
    top: $padding;
    left: $padding;
  }

  &-title {
    margin: 3px 0 4px;

    h4 {
      font-size: 1.05rem;
      line-height: 1.5rem;
      min-height: 1.5rem;
      max-height: 3rem;
    }
  }

  p {
    font-size: 0.9rem;
    line-height: 1.4rem;
  }

  &-details {
    position: relative;
    margin: 0;
    margin-top: 15px;
    bottom: 0;
    left: 0;
    display: flex;

    svg {
      $size: 15px;
      height: $size;
      width: $size;
      fill: var(--textMedium);
      margin-right: 10px;
      margin-top: 4px;
    }

    span {
      font-size: 0.9rem;
      line-height: 1.4rem;
    }
  }
}

@media (max-width: 600px) {
  .job-item {
    $padding: 17px;
    $logoSize: 50px;

    padding: $padding;
    padding-left: calc($padding * 2 + $logoSize);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.07);
    margin-bottom: 17px;
    border-radius: 15px;

    img {
      height: $logoSize;
      width: $logoSize;
      top: $padding;
      left: $padding;
    }

    &-details {
      margin-top: 9px;
    }
  }
}
</style>
